import React, { useState } from 'react';
import { Row, Col } from 'reactstrap';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import { DataGrid } from '@mui/x-data-grid'
import { getOptionsFromListofMaps } from '../../utils';

const UserList = (props) => {

    const handleSelect = (e) => props.onSelect(e.id);

    const handleSelectionChanged = (e) => {
        props.onSelectionChanged(props.data.filter(x => e.find(y => y === x.userId)));
        if (e.length > 0) {
            props.setEnableTrash();
        }
        else
            props.setDisableTrash();
    }
    const roles = getOptionsFromListofMaps(props.roles, 'id', 'name', false)

    const roleIdToChildrenMap = {};
    roles.forEach((role) => {
        roleIdToChildrenMap[role.props.value] = role.props.children;
    });

    const userDisplayObject = props.data.map((item) => ({
        ...item,
        roleName: roleIdToChildrenMap[item.roleId] || "Unknown Role",
    }));
    
    return (
        <Row className='mb-1'>
            <Col>
                <div className='ag-theme-balham' style={{ width: 'auto' }}>
                    <DataGrid
                        rows={userDisplayObject.map(x => { return { id: x.userId, ...x } })}
                        checkboxSelection
                        onRowDoubleClick={handleSelect}
                        onRowSelectionModelChange={handleSelectionChanged}
                        autoHeight={true}
                        rowHeight={35}
                        initialState={{
                            pagination: { paginationModel: { pageSize: 25 } },
                        }}
                        columns={[
                            {
                                headerName: 'Username',
                                field: 'userName',
                                flex: 3,
                            },
                            {
                                headerName: 'Name',
                                field: 'displayName',
                                flex: 3,
                            },
                            {
                                headerName: 'Role',
                                field: 'roleName',
                                flex: 3,
                            }
                        ]}
                        sx={{
                            backgroundColor: 'white'
                        }}
                        getRowClassName={(params) => 'grid-row'}
                    />
                </div>
            </Col>
        </Row>
    )
}

export default UserList